module.exports = __webpack_public_path__ + "media/Audio15_r.09a03126.wav";